import { GridFilterItem, GridFilterModel } from '@mui/x-data-grid-pro';
import { isDateString } from 'functions/date/is-date-string';
import { clientDateToServerDateTime } from 'functions/date/clientDateToServerDate';

const filterValueMapper = new Map<string, string>([
  ['equals', 'eq'],
  ['=', 'eq'],
  ['!=', 'ne'],
  ['>', 'gt'],
  ['>=', 'gte'],
  ['<', 'lt'],
  ['<=', 'lte'],
  ['is', 'is'],
  ['not', 'isNot'],
  ['isEmpty', 'isEmpty'],
  ['isNotEmpty', 'isNotEmpty'],
  ['isAnyOf', 'isAnyOf'],
  ['contains', 'contains'],
  ['startsWith', 'startsWith'],
  ['endsWith', 'endsWith'],
  ['isDate', 'isDate'],
  ['isNotDate', 'isNotDate'],
  ['afterDate', 'afterDate'],
  ['onOrAfterDate', 'onOrAfterDate'],
  ['beforeDate', 'beforeDate'],
  ['onOrBeforeDate', 'onOrBeforeDate'],
]);

const filterDateValueMapper = new Map<string, string>([
  ['is', 'isDate'],
  ['not', 'isNotDate'],
  ['after', 'afterDate'],
  ['onOrAfter', 'onOrAfterDate'],
  ['before', 'beforeDate'],
  ['onOrBefore', 'onOrBeforeDate'],
]);

const buildParam = (
  inputFilter: GridFilterModel,
  currentValue: GridFilterItem
): string => {
  if (
    currentValue?.operatorValue &&
    currentValue?.value &&
    filterValueMapper.has(currentValue.operatorValue)
  ) {
    return `filter[${inputFilter.linkOperator}][${
      currentValue.columnField
    }][${filterValueMapper.get(currentValue.operatorValue)}]=${
      currentValue.value
    }`;
  }
  return '';
};

export const dataGridFilterBuilder = (
  inputFilter?: GridFilterModel
): string => {
  if (
    inputFilter &&
    Object.keys(inputFilter).length &&
    inputFilter.items.length
  ) {
    return inputFilter.items.reduce((query: string, currentValue) => {
      if (
        currentValue?.operatorValue &&
        ['isEmpty', 'isNotEmpty'].includes(currentValue?.operatorValue)
      ) {
        const param = buildParam(inputFilter, {
          ...currentValue,
          value: 1,
        });
        query += query ? `&${param}` : param;
      } else if (
        currentValue?.operatorValue &&
        filterDateValueMapper.has(currentValue.operatorValue) &&
        isDateString(currentValue.value)
      ) {
        const param = buildParam(inputFilter, {
          ...currentValue,
          operatorValue: filterDateValueMapper.get(currentValue.operatorValue),
          value: clientDateToServerDateTime(
            new Date(Date.parse(currentValue.value))
          )?.toISOString(),
        });
        query += query ? `&${param}` : param;
      } else {
        const param = buildParam(inputFilter, currentValue);
        query += query ? `&${param}` : param;
      }
      return query;
    }, '');
  }
  return '';
};
